import { PRODUCTION_IPS } from "@syla/shared/helpers/ipAddresses";

const IPText = PRODUCTION_IPS.join(",");

export const ipPermissions = {
  selfClosing: true,
  render: "CopyableInlineCode",
  attributes: {
    value: {
      type: String,
      default: IPText,
    },
    copyLabel: {
      type: String,
      default: "Copy IP addresses",
    },
  },
};
